<template>
  <div
    :class="$style.container">
    <div
      :class="$style.parallax"
      ref="layer"
      v-for="(image, i) in images"
      :key="image">
      <div
        v-lazy:background-image="image"
        :style="{
          transform: `translateZ(${ 100 * i }px)`
        }"></div>
    </div>
  </div>
</template>

<script>
import gsap from 'gsap'

export default {
  props: ['images'],

  data() {
    return {
      maxRotateX: 12,
      maxRotateY: 12
    }
  },

  computed: {
    halfWidth() {
      return this.$el.clientWidth / 2
    },

    halfHeight() {
      return this.$el.clientHeight / 2
    }
  },

  methods: {
    mousemove(event) {
      const contRect = this.$el.getBoundingClientRect()
      const constOffset = {
        top: contRect.top + document.body.scrollTop,
        left: contRect.left + document.body.scrollLeft
      }

      const mouseX = (event.pageX - constOffset.left) | 0
      const mouseY = (event.pageY - constOffset.top) | 0

      // Move the floating card
      const diffX = this.halfWidth - mouseX
      const diffY = this.halfHeight - mouseY

      this.$refs.layer.forEach((el, i) => {
        const rotationX = (diffY / this.halfHeight * this.maxRotateX) * (i + 1) / 2
        const rotationY = (diffX / this.halfWidth * this.maxRotateY) * (i + 1) / 2
        const y = (diffY / this.halfHeight * this.maxRotateX) * (i + 1)
        const x = (diffX / this.halfWidth * this.maxRotateY) * (i + 1)

        gsap.killTweensOf(el)

        gsap.to(el, 1, {
          rotationX,
          rotationY,
          x,
          y,
          ease: gsap.Power3.easeOut
        })
      })
    },

    mouseleave() {
      this.$refs.layer.forEach((el) => {
        gsap.killTweensOf(el)

        gsap.to(el, 0.4, {
          rotationX: 0,
          rotationY: 0,
          x: 0,
          y: 0,
          ease: gsap.Power3.easeOut
        })
      })
    }
  }
}
</script>

<style module lang="scss">
@import "~sass-mq/mq";

.container {
  position: relative;
  flex: 0 1 auto;

  @include mq(sm) {
    width: 90%;
  }

  &:before {
    content: "";
    display: block;
    width: 100%;
    padding-bottom: 70%;
  }

  .parallax {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;

    > div {
      width: 100%;
      height: 100%;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      transform-style: preserve-3d;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Parallax.vue